
export { useSwitchGroup } from "/app/shared/services/auth/src/hooks/useSwitchGroup/useSwitchGroup.tsx"